import { type HabitMeasure, isBestOfDay, isFast, roundAmount } from './habitMeasure'

// Past an "at least" target: the extra amount and how far the bar's second lap
// has filled (0–1). "At most" and fasting habits never go over in a good way.
export function overTarget(m: HabitMeasure, total: number) {
  if (m.direction !== 'atLeast' || isFast(m) || m.target <= 0 || total <= m.target) return null
  const extra = roundAmount(total - m.target)
  return { extra: isBestOfDay(m) ? null : extra, lap: Math.min(1, extra / m.target) }
}

// Whether a habit can set a daily best worth calling out in its row.
export const tracksDayBest = (m: HabitMeasure) => m.direction === 'atLeast' && !isFast(m)

// Best day strictly before `today`; null when there's no earlier day.
export function bestDayBefore(days: readonly [string, number][], today: string): number | null {
  let best: number | null = null
  for (const [date, value] of days)
    if (date < today && (best === null || value > best)) best = value
  return best
}

export const isNewBest = (total: number, before: number | null | undefined) =>
  before != null && total > before

// The "Done today" group starts folded once it's long enough to crowd the list;
// a choice the user made on this device wins.
export const doneGroupCollapsed = (pref: boolean | null | undefined, count: number) =>
  pref ?? count >= 3

// Habits that just went from pending to done without a tap on their check (a
// number habit reaching its target): they animate out of the pending list.
export function newlyDone(
  prevPending: ReadonlySet<string>,
  doneNow: readonly string[],
  handled: ReadonlySet<string>,
): string[] {
  return doneNow.filter((id) => prevPending.has(id) && !handled.has(id))
}
